"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _react = _interopRequireWildcard(require("react"));
var _VolumeUp = _interopRequireDefault(require("@mui/icons-material/VolumeUp"));
var _useSpeech = require("../hooks/useSpeech");
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)({
  micContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.3s ease-in-out'
  },
  micIcon: {
    fontSize: 30,
    color: 'black'
  },
  listening: {
    animation: '$pulse 1.5s infinite'
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 5px #ff4081'
    },
    '50%': {
      boxShadow: '0 0 15px #ff4081, 0 0 25px #ff4081'
    },
    '100%': {
      boxShadow: '0 0 5px #ff4081'
    }
  }
});
const SpeakerButton = ({
  text,
  handleClick,
  id,
  currentPlayingId,
  iconProps,
  isAIAnswering
}) => {
  const {
    isSpeaking,
    currentText,
    speak,
    stop
  } = (0, _useSpeech.useSpeech)();
  const classes = useStyles();
  (0, _react.useEffect)(() => {
    if (isAIAnswering && text) {
      const timer = setTimeout(() => {
        handlePlayStop();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [text, isAIAnswering, speak]);
  const handlePlayStop = () => {
    isSpeaking ? stop() : speak(text);
    handleClick(id);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: "Speak",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      onClick: handlePlayStop,
      className: currentPlayingId === id && isSpeaking ? classes.listening : '',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VolumeUp.default, {
        ...iconProps
      })
    })
  });
};
var _default = exports.default = SpeakerButton;